export default (theme) => ({
  textField: {
    width: "100%",
    marginBottom: theme.spacing(2),
  },
  fieldError: {
    color: theme.palette.error.main,
    marginTop: theme.spacing(-1.5),
    marginBottom: theme.spacing(1.5),
  },
  dropdownOptionPrimary: {
    fontWeight: 500,
    lineHeight: 1.3,
  },
  dropdownOptionSecondary: {
    color: theme.palette.text.secondary,
    lineHeight: 1.3,
    marginTop: theme.spacing(0.25),
  },
  menu: {
    maxHeight: 320,
  },
  notListedOption: {
    color: theme.palette.error.main,
  },
  selectPlaceholder: {
    color: theme.palette.text.secondary,
  },
  horizontalField: {
    paddingRight: theme.spacing(2),
  },
  splitColumn: {
    paddingRight: theme.spacing(2),
  },
  brokerageAddressField: {
    marginTop: theme.spacing(3),
  },
  brokerageAddressLine: {
    marginTop: theme.spacing(0.5),
  },
});
